import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import AdminGemstoneReportService from "../../../services/reports-AdminGemstone-service";
import ReportScaffold from "../../ChartsGroup/GemstoneReportsCharts/_shared/ReportScaffold";
import AdminDetailSearchTable from "./_shared/AdminDetailSearchTable";
import { GEMTYPE_CONFIG } from "../../ChartsGroup/GemstoneReportsCharts/_shared/reportConfigs";
import { exportChartPdf } from "../../ChartsGroup/GemstoneReportsCharts/_shared/exportChartPdf";
import GlobalGemstoneReportService from "../../../services/reports-globalGemstone-service";
import { message } from "antd";
import { BlobToDownloadFile } from "../../../helper/commanFunction";

const GemstoneGemTypeReport = () => {
  const loginDetials = useSelector((state) => state.loginReducer);

  const initialGlobalGemstoneState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
    SelectedGemstoneValue: "All",
    retailerIds: [],
    vendorIds: [],
  };

  const [globalGemstones, setGlobalGemstone] = useState(initialGlobalGemstoneState);
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(null);
  const [dealerId, setDealerId] = useState();
  const [forDealer, setForDealer] = useState("");
  const [refetchToken, setRefetchToken] = useState(0);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [activityPdfLoading, setActivityPdfLoading] = useState(false);
  const [chartFilterValue, setChartFilterValue] = useState("");
  const [chartType, setChartType] = useState("doughnut");

  useEffect(() => {
    if (loginDetials?.loginDetials?.responseData?.logInSucceeded) {
      setDealerId(loginDetials.loginDetials.responseData.dealerId);
      handleCheckDealermembers(loginDetials.loginDetials.responseData.dealerId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCheckDealermembers = (id) => {
    AdminGemstoneReportService.CheckDealermembers({ dealerID: id })
      .then((response) => {
        if (response.data.message === "Success") {
          const responseData = response.data.responseData;
          const fd = Object.keys(responseData).length !== 0 ? responseData.forDealer : "";
          setForDealer(fd || "");
          handleLoadReport(id, fd);
        } else {
          setForDealer("");
        }
      })
      .catch(() => setForDealer(""));
  };

  const handleLoadReport = (dealerIdArg, forDealerArg) => {
    let inputData = {
      dealerID: dealerIdArg.toString(),
      forDealer: forDealerArg ? forDealerArg.toString() : "",
      fromDate: globalGemstones.dataRangeFrom
        ? moment(globalGemstones.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalGemstones.dataRangeTo
        ? moment(globalGemstones.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      retailerIds: globalGemstones.retailerIds.toString(),
      vendorIds: globalGemstones.vendorIds.toString(),
      selectedGemstoneValue: globalGemstones.SelectedGemstoneValue,
      type: "Global",
      reportName: "ExtendedGemstoneCharts",
    };

    setLoading(true);
    AdminGemstoneReportService.LoadChartReports(inputData)
      .then((response) => {
        setLoading(false);
        if (response.data.message === "Success" && response.data.responseData) {
          setReport(response.data.responseData);
        } else {
          setReport(null);
        }
      })
      .catch(() => {
        setLoading(false);
        setReport(null);
      });
  };

  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalGemstone((prevState) => ({
        ...prevState,
        dataRangeFrom: dateStrings[0],
        dataRangeTo: dateStrings[1],
      }));
    }
  };

  const onGemstoneTypeChange = (e, name) => {
    setGlobalGemstone({ ...globalGemstones, [name]: e });
  };

  const handleApplyFilter = () => {
    handleLoadReport(dealerId, forDealer);
    setRefetchToken((tok) => tok + 1);
  };

  // Clicking a chart slice/bar filters the detail table to that value;
  // clicking the same slice again (or the clear badge) toggles it back off.
  const handleChartSliceClick = (label) => {
    setChartFilterValue((prev) => (prev === label ? "" : label));
  };

  const handleDownloadChart = async () => {
    setPdfLoading(true);
    try {
      await exportChartPdf({
        elementId: "pdf-content",
        title: GEMTYPE_CONFIG.pageTitle,
        dealerCompany: loginDetials?.loginDetials?.responseData?.dealerCompany,
        dealerId,
        dataRangeFrom: globalGemstones.dataRangeFrom,
        dataRangeTo: globalGemstones.dataRangeTo,
        selectedGemstoneValue: globalGemstones.SelectedGemstoneValue,
        totalClicks: report?.TotalGemstoneClicks?.[0]?.TotalClickCnt,
        fileName: "Gemstone-Type-Search-Report.pdf",
      });
    } finally {
      setPdfLoading(false);
    }
  };

  // Backend "Download PDF" (chart + Ranked Breakdown) - same as the admin
  // Diamond report pages, which reuse the Global-scope ExportMetricPdf since
  // the admin data is the same combined ExtendedGemstoneCharts query.
  const handleDownloadActivityPdf = () => {
    let inputData = {
      dealerID: dealerId ? dealerId.toString() : "",
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: moment(globalGemstones.dataRangeFrom).format("YYYY-MM-DD"),
      toDate: moment(globalGemstones.dataRangeTo).format("YYYY-MM-DD"),
      retailerIds: globalGemstones.retailerIds.toString(),
      vendorIds: globalGemstones.vendorIds.toString(),
      selectedGemstoneValue: globalGemstones.SelectedGemstoneValue,
      type: "",
      reportName: "GemType",
      barViewDimensions: chartType === "bar" ? "GemType" : "",
    };
    setActivityPdfLoading(true);
    GlobalGemstoneReportService.ExportMetricPdf(inputData)
      .then((response) => {
        setActivityPdfLoading(false);
        const filename = `Gemstone_GemType_Admin_${globalGemstones.dataRangeFrom}_${globalGemstones.dataRangeTo}.pdf`;
        BlobToDownloadFile(response.data, filename, "pdf");
      })
      .catch(() => {
        setActivityPdfLoading(false);
        message.error("Failed to generate PDF. Please try again.");
      });
  };

  return (
    <ReportScaffold
      config={GEMTYPE_CONFIG}
      report={report}
      loading={loading}
      dealerId={dealerId}
      forDealer={forDealer}
      dealerCompany={loginDetials?.loginDetials?.responseData?.dealerCompany}
      globalGemstones={globalGemstones}
      onDateChange={onDateChange}
      onGemstoneTypeChange={onGemstoneTypeChange}
      onApplyFilter={handleApplyFilter}
      refetchToken={refetchToken}
      onDownloadChart={handleDownloadChart}
      downloadingChart={pdfLoading}
      onDownloadActivityPdf={handleDownloadActivityPdf}
      onChartClick={handleChartSliceClick}
      chartFilterValue={chartFilterValue}
      downloadingActivityPdf={activityPdfLoading}
      onChartTypeChange={setChartType}
      detailTable={
        <AdminDetailSearchTable
          dealerId={dealerId}
          forDealer={forDealer}
          dataRangeFrom={globalGemstones.dataRangeFrom}
          dataRangeTo={globalGemstones.dataRangeTo}
          selectedGemstoneValue={globalGemstones.SelectedGemstoneValue}
          reportName={GEMTYPE_CONFIG.detail.reportName}
          filterParamName={GEMTYPE_CONFIG.detail.filterParamName}
          filterValue={chartFilterValue}
          filterViaSearchText={GEMTYPE_CONFIG.detail.filterViaSearchText}
          fileNamePart="GemstoneGemType_Report"
          refetchToken={refetchToken}
        />
      }
    />
  );
};

export default GemstoneGemTypeReport;
